/** Example output: 6:30 PM - 7:30 PM */
export const formatTimeRange = (
  appointmentStartTime?: string | null,
  appointmentEndTime?: string | null,
): string | JSX.Element => {
  if (!appointmentStartTime || !appointmentEndTime) {
    return '';
  }

  const formattedStartTime = new Date(appointmentStartTime).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  });

  const formattedEndTime = new Date(appointmentEndTime).toLocaleTimeString([], {
    hour: 'numeric',
    minute: 'numeric',
  });

  return (
    <>
      {formattedStartTime} <span className='sr-only'>to</span>
      <span aria-hidden>-</span> {formattedEndTime}
    </>
  );
};

/** example output: "Mon, Jun 24" */
export const formatShortAppointmentDate = (date: string) => {
  return new Date(date).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};

/** example output: "PDT" */
export const getBrowserTimezone = () => {
  return new Date().toLocaleTimeString(undefined, { timeZoneName: 'short' }).split(' ')[2];
};

/** Example output: "August 17 at 5:00 PM PST" */
export const formatNextAppointmentDateTime = (timeStart: string) => {
  const date = new Date(timeStart);
  const monthDay = date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  const timeWithTz = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    timeZoneName: 'short',
  });

  return `${monthDay} at ${timeWithTz}`;
};

type NextAppointment = {
  id: string;
  timeStart: unknown;
};

export function hasScheduledFollowUp(
  nextAppointment: NextAppointment | null | undefined,
  currentSessionEndTime: string | undefined,
): nextAppointment is NextAppointment {
  if (!nextAppointment?.timeStart || !currentSessionEndTime) {
    return false;
  }

  const nextStart = new Date(String(nextAppointment.timeStart)).getTime();
  const sessionEnd = new Date(currentSessionEndTime).getTime();

  return nextStart > sessionEnd;
}
